var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDrapeauFr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.14286 16.0709H0.372294C0.164502 16.0709 0 15.8991 0 15.692V2.16399C0 1.95255 0.168831 1.78516 0.372294 1.78516H7.14286V16.0709Z",
    fill: "#41479B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2835 1.78516H7.14062V16.0709H14.2835V1.78516Z",
    fill: "#F5F5F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0596 16.0709H14.2891V1.78516H21.0596C21.2674 1.78516 21.4319 1.9569 21.4319 2.16388V15.6877C21.4319 15.8991 21.2631 16.0709 21.0596 16.0709Z",
    fill: "#FF4B55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.952148 0.9375H0.961914C1.43891 0.9375 1.82422 1.32281 1.82422 1.7998V23.2061C1.82422 23.6775 1.43469 24.0635 0.961914 24.0635C0.484916 24.0635 0.0996094 23.6782 0.0996094 23.2012V1.79004C0.0996094 1.31792 0.480033 0.9375 0.952148 0.9375Z",
    fill: "#4E5462",
    stroke: "#3B3C3D",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrapeauFr);
export default __webpack_public_path__ + "static/media/drapeau_FR.4a7ae6cde6fb1382ab691bc05189dc5e.svg";
export { ForwardRef as ReactComponent };